<template>
  <div>
    <Card>
      <Form :label-width="80" inline @submit.native.prevent>
        <Row style="padding: 20px">
          <Col span="24">
            <FormItem label="模板名称:">
              <label>
                <Input
                  placeholder="请输入模板名称"
                  v-model="params.cname"
                  clearable
                  class="search"
                ></Input>
              </label>
            </FormItem>
            <FormItem label="优惠券类型:">
              <label>
                <Select style="width: 100px" v-model="params.ctype">
                  <Option value="0">=全部=</Option>
                  <Option
                    v-for="(v, k, i) in CoupontempType"
                    :key="i"
                    :value="k"
                    >{{ v }}
                  </Option>
                </Select>
              </label>
            </FormItem>
            <FormItem label="状态:">
              <label>
                <Select style="width: 100px" v-model="params.status">
                  <Option value="-1">=全部=</Option>
                  <Option
                    v-for="(v, k, i) in CoupontempStatus"
                    :value="k"
                    :key="i"
                    >{{ v }}
                  </Option>
                </Select>
              </label>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem
              label="有效期:"
              style="width: 220px"
              v-model="params.beginDate"
            >
              <DatePicker
                type="date"
                format="yyyy-MM-dd"
                placeholder="开始日期"
                @on-change="changeBeginDate"
              ></DatePicker>
            </FormItem>
            <FormItem
              label="失效日期"
              style="width: 220px"
              v-model="params.endDate"
            >
              <DatePicker
                type="date"
                format="yyyy-MM-dd"
                placeholder="失效日期"
                @on-change="changeEndDate"
              ></DatePicker>
            </FormItem>
            <!-- <FormItem label="所属平台:">
              <label>
                <Select style="width:100px;" v-model="params.platformCode">
                  <Option value="-1">=全部=</Option>
                  <Option v-for="(item,index) in CouponPlatform"
                          :key="index" :value="item.code">{{ item.name }}
                  </Option>
                </Select>
              </label>
            </FormItem> -->
            <FormItem>
              <Button
                type="primary"
                icon="md-search"
                @click="queryByCondition"
                v-access="'coupon.template.list.query'"
                >查询</Button
              >
              <Button
                type="success"
                icon="md-add-circle"
                @click="createCouponTemplate"
                v-access="'coupon.template.list.add'"
                >创建</Button
              >
            </FormItem>
          </Col>
        </Row>
      </Form>
    </Card>
    <Card style="margin-top: 20px">
      <Row style="padding: 20px">
        <Table
          class="table"
          border
          stripe
          height="500"
          :loading="loading"
          :columns="columnlist"
          :data="CoupontempList"
        >
          <!-- <template slot-scope="{row, index}" slot="statusName">
            <span v-if="row.status==='0'" style="color:black;">正常</span>
            <span v-if="row.status==='1'" style="color:red;">已停用</span>
          </template> -->
          <template slot-scope="{ row, index }" slot="status">
            <span v-if="row.isIssue === 0"
              ><a
                v-access="'coupon.template.list.edit'"
                type="text"
                size="small"
                style="margin-right: 5px"
                @click="editCouponTemplate(row, index)"
                >编辑</a
              ></span
            >
            <span v-if="row.status === '0'" style="color: black">
              <a
                v-access="'coupon.template.list.status'"
                type="text"
                size="small"
                style="margin-right: 5px"
                @click="disableCouponTemplate(row, index)"
                >停用</a
              >
              <a
                v-access="'coupon.template.list.edit'"
                type="text"
                size="small"
                style="margin-right: 5px"
                @click="applyCoupon(row, index)"
                >申请发放</a
              ></span
            >
            <span v-if="row.status === '1'" style="color: green">
              <a
                v-access="'coupon.template.list.status'"
                type="text"
                size="small"
                style="margin-right: 5px"
                @click="activeCouponTemplate(row, index)"
                >启用</a
              ></span
            >
          </template>
        </Table>
      </Row>
      <Row type="flex" justify="end">
        <page
          :total="totalCnt"
          :page-size="params.pageSize"
          :page-size-opts="[10, 20, 30, 50]"
          @on-change="pageNumChange"
          @on-page-size-change="pageSizeChange"
          show-total
          show-sizer
          class-name="pagination justify-content-end mg-10"
        />
      </Row>
    </Card>
  </div>
</template>

<script>
const columnlist = [
  {
    title: "优惠券编码",
    key: "code",
    tooltip: true,
    width: 250,
  },
  {
    title: "名称",
    key: "cname",
    tooltip: true,
    width: 200,
  },
  {
    title: "优惠券类型",
    key: "ctypeName",
    width: 150,
  },
  {
    title: "状态",
    key: "statusName",
    width: 120,
  },
  // {
  //   title: '启用金额(元)',
  //   key: 'minAmount',
  //   width: 120
  // },
  // {
  //   title: '门店限发张数',
  //   key: 'lmtCnt',
  //   width: 120
  // },
  {
    title: "创建时间",
    key: "createtime",
    width: 120,
  },
  {
    title: "生效日期",
    key: "beginDate",
    width: 120,
  },
  {
    title: "失效日期",
    key: "endDate",
    width: 120,
  },
  // {
  //   title: '所属平台',
  //   key: 'platformName',
  //   width: 150
  // },
  // {
  //   title: '使用说明',
  //   key: 'couponDesc',
  //   width: 220,
  //   tooltip: true
  // },
  {
    title: "操作",
    slot: "status",
    width: 200,
    fixed: "right",
  },
];
export default {
  name: "couponTemplateList",
  data() {
    return {
      loading: false,
      columnlist,
      CoupontempType: {},
      CoupontempStatus: {},
      CouponPlatform: {},
      params: {
        code: "",
        cname: "",
        platformCode: "-1",
        ctype: "0",
        status: "-1",
        beginDate: "",
        endDate: "",
        pageSize: 10,
        pageNum: 1,
      },
      CoupontempList: [],
      totalCnt: 0,
    };
  },
  methods: {
    showPlatformName(code) {
      for (let i = 0; i < this.CouponPlatform.length; i++) {
        if (code === this.CouponPlatform[i].code) {
          return this.CouponPlatform[i].name;
        }
      }
    },
    changeBeginDate(d) {
      this.params.beginDate = d;
    },
    changeEndDate(d) {
      this.params.endDate = d;
    },
    pageNumChange(p) {
      this.params.pageNum = p;
      this.queryCouponTemplatelist();
    },
    pageSizeChange(p) {
      this.params.pageSize = p;
      this.queryCouponTemplatelist();
    },
    queryByCondition() {
      this.params.pageNum = 1;
      this.queryCouponTemplatelist();
    },
    queryCoupontemptype() {
      let http = "couponTemplateType";
      this.$api[http]({}).then((res) => {
        if (res.code === "200") {
          //this.$Message.success('查询优惠券类型枚举成功');
          this.CoupontempType = res.data.CoupontempType;
        } else {
          this.$Message.error("查询优惠券类型枚举失败.");
        }
      });
    },
    queryCoupontempStatus() {
      let http = "couponTemplateStatus";
      this.$api[http]({}).then((res) => {
        if (res.code === "200") {
          //this.$Message.success('查询优惠券状态枚举成功');
          this.CoupontempStatus = res.data.CoupontempStatus;
        } else {
          this.$Message.error("查询优惠券状态枚举失败.");
        }
      });
    },
    queryBusiPlatform() {
      let http = "couponqueryBusiPlatform";
      this.$api[http]({}).then((res) => {
        if (res.code === "200") {
          //this.$Message.success('查询优惠券业务平台枚举成功');
          this.CouponPlatform = res.data.CouponPlatform;
        } else {
          this.$Message.error("查询优惠券业务平台枚举失败.");
        }
      });
    },
    queryCouponTemplatelist() {
      this.loading = true;
      let http = "queryCouponTemplatelist";
      this.$api[http](this.params).then((res) => {
        if (res.code === "200") {
          this.$Message.success("查询优惠券模板列表成功");
          this.CoupontempList = res.data.list;
          this.totalCnt = res.data.total;
          this.CoupontempList.forEach((t) => {
            t.createtime = t.createtime ? t.createtime.substr(0, 10) : "";
            t.beginDate = t.beginDate ? t.beginDate.substr(0, 10) : "";
            t.endDate = t.endDate ? t.endDate.substr(0, 10) : "";
            t.platformName = this.showPlatformName(t.platformCode);
          });
        } else {
          this.$Message.error("查询优惠券模板列表失败.");
        }
        this.loading = false;
      });
    },
    createCouponTemplate() {
      this.$router.push({
        path: "create",
      });
    },
    editCouponTemplate(row, index) {
      this.$router.push({
        name: "coupon_template_create",
        query: {
          code: row.code,
          applyCode: "",
        },
        //path: "create",
        //query: {
        //  code: row.code,
        //},
      });
    },
    disableCouponTemplate(row, index) {
      this.$Modal.confirm({
        title: "停用模板",
        content: "<p>是否要停用该模板？</p>",
        onOk: () => {
          let http = "disableCouponTemplate";
          let query = { code: row.code };
          this.$api[http](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success(res.data.message);
                row.status = "1";
              } else {
                this.$Message.error(res.data.message);
              }
            } else {
              this.$Message.error("停用优惠券模板失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    activeCouponTemplate(row, index) {
      this.$Modal.confirm({
        title: "启用模板",
        content: "<p>是否要启用该模板？</p>",
        onOk: () => {
          let http = "activeCouponTemplate";
          let query = { code: row.code };
          this.$api[http](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success(res.data.message);
                row.status = "0";
              } else {
                this.$Message.error(res.data.message);
              }
            } else {
              this.$Message.error("启用优惠券模板失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    applyCoupon(row, index) {
      let http = "queryTemplateDetail";
      let query = { code: row.code };
      this.$api[http](query).then((res) => {
        if (res.code === "200") {
          if (res.data.status !== "0") {
            this.$Message.error("优惠券模板为停用状态,不能申请发放.");
          } else {
            this.$router.push({
              name: "coupon_apply_create",
              query: {
                code: row.code,
                applyCode: "",
              },
            });
          }
        } else {
          this.$Message.error("启用优惠券模板失败.");
        }
      });
    },
  },
  created() {
    this.queryBusiPlatform();
  },
  watch: {
    CouponPlatform(n, o) {
      this.queryCoupontemptype();
    },
    CoupontempType(n, o) {
      this.queryCoupontempStatus();
    },
    CoupontempStatus(n, o) {
      this.queryCouponTemplatelist();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/coupon/template/list.vue